export const statusType = {
    ACTIVE: 'active',
    PAUSED: 'paused',
    COMPLETED: 'completed'
};